import reactLogo from "../img/LOGO-Icontec-2019_ver_pos (2).png";

export const ReactLogo = () => {
  return (
    <img
      src={reactLogo}
      alt="React Logo"
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        width: "90px",
      }}
    />
  );
};
